import { TextField } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import React from 'react';
import Datatype from './Datatype';
import { globalStyles } from './style/gstheme';
import { DATATYPES } from './utils/constants';

const styles = Object.assign({}, globalStyles);

class DatetimeField extends React.Component {

    handleDelete = () => this.props.onDelete(this.props.dateTime);

    render() {

        const { classes, isReadOnly, dateTime, invalidDatatype, displayDatatype } = this.props;
        const m = new Date(dateTime);
        const displayText =
            m.getUTCFullYear() + "/" +
            ("0" + (m.getUTCMonth() + 1)).slice(-2) + "/" +
            ("0" + m.getUTCDate()).slice(-2) + " " +
            ("0" + m.getUTCHours()).slice(-2) + ":" +
            ("0" + m.getUTCMinutes()).slice(-2) + ":" +
            ("0" + m.getUTCSeconds()).slice(-2);

        return (
            <TextField
                data-test="date-time"
                value={displayText + " (UTC)"}
                variant="outlined"
                margin="dense"
                style={{ marginTop: 0 }}
                fullWidth
                helperText={invalidDatatype ? <span data-test="helper-text">This value is no longer valid for the property's datatype</span> : ""}
                InputProps={{
                    className: classes.inputLabel,
                    startAdornment: displayDatatype ? <Datatype datatype={DATATYPES.DATETIME} invalid={invalidDatatype} /> : null,
                    endAdornment: !isReadOnly &&
                        <InputAdornment position="end" onClick={this.handleDelete}>
                            <IconButton size="small">
                                <DeleteIcon data-test="delete-datetime" fontSize="small" />
                            </IconButton>
                        </InputAdornment>,
                    inputProps: {
                        "data-test": "datetime-value",
                        readOnly: true,
                        maxLength: this.props.maxLength
                    }
                }
                }
            />
        );
    }
}

DatetimeField.defaultProps = {
    isReadOnly: false,
    invalidDatatype: false,
    displayDatatype: true
};

DatetimeField.propTypes = {
    isReadOnly: PropTypes.bool,
    invalidDatatype: PropTypes.bool,
    onDelete: PropTypes.func,
    onUpdate: PropTypes.func,
    maxLength: PropTypes.number,
    displayDatatype: PropTypes.bool,
    dateTime: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(DatetimeField);